import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Input } from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";

import { useDispatch, useSelector } from "react-redux";
import PlaceList from "../../Components/Places/PlaceList";
import { getWaterfallsRequest } from "../../store/waterfall/actions";
import { useDebounce } from "use-debounce";

const WaterFallList = () => {
  document.title = "Atrativos naturais | Ecoguias - Admin Dashboard";

  const history = useHistory();
  const { search } = useLocation();

  const dispatch = useDispatch();
  const { data, loading, success } = useSelector((state) => state.Waterfall);

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  const queryStringParams = queryString.parse(search);

  useEffect(() => {
    dispatch(getWaterfallsRequest(value));
  }, [dispatch, value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Atrativos naturais" pageTitle="Locais" />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={() => history.push("/waterfalls-form")}
            >
              Cadastrar
            </button>
          </div>

          <PlaceList
            loading={loading}
            success={success}
            data={data?.result}
            pathPaginationName="/waterfalls"
            page={queryStringParams.page}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WaterFallList;
